import PropTypes from 'prop-types';
import React, { Component } from 'react';
import classNames from 'classnames';

import { trendClass } from 'utils/trend';

/** TODO
 *  Make this component iterate over children and manipulate classes instead of
 *  wrapping in a span
 */

export default class Trend extends Component {
  static propTypes = {
    value: PropTypes.number,
  };

  render() {
    const { children, value } = this.props;
    return <span className={classNames(trendClass(value))}>{children}</span>;
  }
}
